import DeleteTagRequestModelBase from '../_generated/modelBases/delete-tag-request-model-base';

export default class DeleteTagRequestModel extends DeleteTagRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
